/* React */
import React from "react";

/* Ionic */
import { ellipseOutline, radioButtonOn } from "ionicons/icons";

/* Components */
import CheckboxItem from "src/components/shared/checkbox-item/CheckboxItem";

/* Interfaces */
interface ShowNoValueEntriesProps {
  showNoValueEntries: boolean;
  handleShowNoValueEntries: () => void;
  disabled?: boolean;
}

const ShowNoValueEntries: React.FC<ShowNoValueEntriesProps> = ({
  showNoValueEntries,
  handleShowNoValueEntries,
  disabled = false,
}) => {
  // When disabled (a custom cohort is active), always read as off - never show
  // an "on" radio a stale slice value would otherwise leave behind.
  const isOn = showNoValueEntries && !disabled;

  return (
    <CheckboxItem
      label={"Show no-value entries"}
      icon={isOn ? radioButtonOn : ellipseOutline}
      onClick={handleShowNoValueEntries}
      disabled={disabled}
    />
  );
};

export default ShowNoValueEntries;
